import React, { Component } from "react";

import { PropertyPanelContainer } from "js/EditorComponents/PropertyPanel";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import { _ } from "js/vendor";
import styled from "styled-components";
import { CanvasEventType } from "../../../common/constants";
import { PropertyPanelButton } from "../../EditorComponents/PropertyPanelButton";
import { themeColors } from "../../react/sharedStyles";
import { PropertyPanelHeader } from "../ElementEditor/PropertyPanelHeader";
import PresentationEditorController from "../PresentationEditor/PresentationEditorController";
import SlideAiController from "./SlideAiController";
import SlideAiDialog from "./SlideAiDialog";
import SlideAiIdeasList from "./SlideAiIdeasList";

const SlidePreviews = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    padding: 10px 15px;
`;

const SlideCategory = styled.div`
    display: flex;
    gap: 10px;
    flex-direction: column;
`;

const CategoryLabel = styled.div`
    display: flex;
    font-weight: bold;
    padding: 10px 0px 0px;
    align-items: center;
    justify-content: center;
`;

const CanvasPreviewWrapper = styled.div`
    position: relative;
    width: 250px;
    height: 140px;
    cursor: pointer;
    border: solid 1px #ccc;
    overflow: hidden;
    outline: ${props => props.selected ? `3px solid ${themeColors.ui_blue}` : "none"};
`;

class SlideAiIdeasPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentModel: _.cloneDeep(props.currentSlide.attributes),
            isGenerating: false,
            selectedModel: null,
            slideCategory: null,
            slideCategories: [],
            // generatedSlides: props.currentSlide.getMetadata()?.generatedSlides ?? []
        };

        this.hasBeenUnmounted = false;

        this.slideAiIdeasListRef = React.createRef();
    }

    componentDidMount() {
        const { currentSlide, canvasController } = this.props;
        // if (currentSlide.getMetadata()?.hasBeenViewed === false) {
        currentSlide.updateMetadata({ hasBeenViewed: true });

        if (SlideAiController.currentSlide !== currentSlide) {
            SlideAiController.setCurrentSlide(currentSlide, canvasController);
        }

        // const metadata = currentSlide.getMetadata();
        // this.setState({ slideGen: currentSlide.getMetadata() });
        // this.renderSlideModels(currentSlide.getMetadata()?.generatedSlides ?? [], true);

        // }
    }

    componentDidUpdate(prevProps, prevState) {
        const { canvasController, currentSlide } = this.props;

        if (prevProps.currentSlide !== currentSlide) {
            this.setState({
                currentModel: _.cloneDeep(currentSlide.attributes),
                isGenerating: false,
                selectedModelIndex: null,
                slideCategory: null
            });
        }
    }

    componentWillUnmount() {
        this.hasBeenUnmounted = true;
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.canvasController?.canvas?.isAnimating;
    }

    setStateAsync = async stateUpdate => {
        await new Promise(resolve => this.setState(stateUpdate, resolve));
    }

    handleRegenerateSlide = () => {
        const { currentSlide, currentCanvasController } = this.props;
        let { ideas } = ShowDialog(SlideAiDialog, { currentSlide, currentCanvasController });
        this.setState({ generatedSlides: ideas });
    }

    handleRegenerateImage = async () => {
        SlideAiController.regenerateSlideImage();
        // const { currentSlide, currentTheme, generatedIdeas } = this.props;
        //
        // const metadata = currentSlide.getMetadata();
        // const slideImage = metadata.generatedModel?.slideImage;
        // const imageSource = metadata.imageSource ?? "ai";
        //
        // let { imagePrompt, imageStyle } = await ShowDialogAsync(RegenerateImageDialog, {
        //     currentSlide,
        //     theme: currentTheme,
        //     prompt: slideImage?.prompt || "",
        //     imageSource: imageSource,
        //     imageStyle: slideImage?.imageStyle || "minimalist",
        // });
        //
        // if (!imagePrompt) {
        //     return;
        // }
        //
        // imageStyle = imageStyle || slideImage?.imageStyle || "";
        //
        // await currentSlide.resetSlideImage();
        //
        // const generatedSlides = currentSlide.getMetadata()?.generatedSlides;
        // // this.renderSlideModels(generatedSlides, true);
        //
        // const { slide } = await AiGenerationService.regenerateSlideImage({
        //     slide: currentSlide.attributes,
        //     imagePrompt,
        //     imageStyle
        // });
        //
        // currentSlide.update(slide);
        // await currentSlide.updatePromise;
        //
        // // this.renderSlideModels(generatedSlides, true);
    }

    /*regenerateSlide = async slideGen => {
        if (!slideGen) return;

        const { currentSlide } = this.props;

        this.setState({
            currentModel: _.cloneDeep(currentSlide.attributes),
            isGenerating: true,
            selectedModelIndex: 0,
        });

        currentSlide.update({ metadata: { ...currentSlide.getMetadata(), ...slideGen } });
        console.log("Regenerating slide with state:", slideGen);

        let response = await AiGenerationService.generateSlideData({
            slideId: currentSlide.id,
            presentationId: currentSlide.presentation.id,
            slidePrompt: slideGen.slidePrompt,
            slideType: slideGen.slideType,
            slideIndex: currentSlide.getIndex(),
            preserveExactText: slideGen.preserveExactText || false,
            files: slideGen.files || [],
            presentationTopic: currentSlide.presentation.get("metadata").topic
        });

        console.log(response);

        if (!response.slides || response.slides.length == 0) {
            ShowWarningDialog({ title: "Slide AI", message: "Sorry, we couldn't generate a new slide for you. Please try again." });
            this.setState({ isGenerating: false });
            return;
        }

        this.renderSlideModels(response.slides, slideGen.slidePrompt);
    }

    renderSlideModels = async (generatedSlides, slidePrompt) => {
        const { currentSlide } = this.props;

        let slideCategories = [];
        for (let slide of generatedSlides) {
            let slideModel = slide.slideData;
            slideModel.slideImage = currentSlide.getMetadata().generatedModel?.slideImage;
            slideModel.imageStylePrompt = currentSlide.getMetadata().imageStylePrompt;

            console.log("Category", slideModel.slideCategory);
            console.log("Reasoning:", slideModel.slideReasoning);
            console.log(slideModel);

            let category = CategoryController.getCategory(slideModel.slideCategory);
            let models = category.getSlideModels(slideModel);

            // copy over metadata from the generated slide data
            models = models.map(model => ({
                ...model,
                metadata: {
                    ...currentSlide.getMetadata(),
                    ...model.metadata,
                    generatedSlides,
                    aiGenerated: true,
                    originalSlidePrompt: slidePrompt,
                    slidePrompt: slideModel.slidePrompt,
                    slideCategory: slideModel.slideCategory,
                    slideReasoning: slideModel.slideReasoning,
                    slideConfidence: slideModel.slideConfidence
                }
            }));

            models.forEach(model => {
                let elementsWithImages = findElementsWithImages(model);
                for (let element of elementsWithImages) {
                    if (!element.content_value && element.__generateImage) {
                        element.__generateImage.isGenerating = true;
                    }
                }
            });

            slideCategories.push({
                slideCategory: slideModel.slideCategory,
                slideReasoning: slideModel.slideReasoning,
                slideConfidence: slideModel.slideConfidence,
                models
            });
        }

        await this.setStateAsync({
            slideCategories,
            isGenerating: false
        });

        for (let cat of slideCategories) {
            let models = cat.models;
            for (let idx = 0; idx < models.length; idx++) {
                let { slide } = await AiGenerationService.generateImagesForSlide({
                    slide: models[idx]
                });

                if (this.state.slideCategories !== slideCategories || this.hasBeenUnmounted) {
                    // If the preview models have changed or the component has been unmounted, stop generation
                    break;
                }

                let { update, hasUpdates } = computeChangeSet(models[idx], slide);
                if (hasUpdates) {
                    let updatedModel = mergeChanges(models[idx], update);
                    this.setState(state => {
                        // Keep the array reference, only replace a single model
                        const slideCategories = state.slideCategories;
                        slideCategories[slideCategories.indexOf(cat)].models[idx] = updatedModel;
                        return {
                            ...state,
                            slideCategories
                        };
                    });
                }
            }
        }
    }
    */

    handleApplySlide = model => {
        const { currentSlide, currentCanvasController, closePopup } = this.props;

        currentCanvasController.canvas.once(CanvasEventType.REFRESH, () => {
            // this.props.closeDialog();
            window.requestAnimationFrame(() => {
                PresentationEditorController.playAnimation();
            });
        });

        currentSlide.update({
            ...currentSlide.attributes,
            animations: {},
            states: model.states,
            layout: model.layout,
            template_id: model.template_id,
            version: 10,
            migrationVersion: 10.03,
            metadata: {
                ...model.metadata,
                needsLayoutProcessing: true
            }
        }, { removeMissingKeys: true });
    }

    render() {
        let { currentSlide, generatedIdeas } = this.props;
        let { isGenerating } = this.state;

        if (currentSlide !== SlideAiController.currentSlide) {
            return null;
        }

        if (generatedIdeas?.length > 0 || isGenerating) {
            return (
                <PropertyPanelContainer fullHeight style={{ background: "#444" }}>
                    <PropertyPanelHeader showCloseButton>Slide AI</PropertyPanelHeader>

                    {/*<label>Slide Type:{currentSlide.getMetadata().slideType}</label>*/}
                    {/*<div style={{ padding: 10, fontSize: 14, maxHeight: 300, overflowY: "scroll" }} dangerouslySetInnerHTML={{ __html: currentSlide.getMetadata()?.slideContent }} />*/}
                    <PropertyPanelButton icon="change_circle"
                        title="Regenerate Slide..."
                        description="Switch any other smart slide and we'll try to preserve your existing content as best we can."
                        onClick={this.handleRegenerateSlide}
                    />
                    <PropertyPanelButton icon="photo"
                        title="Regenerate image..."
                        onClick={() => SlideAiController.regenerateSlideImage()}
                        disabled={currentSlide.getMetadata().imageSource === "none"}
                    />

                    <SlideAiIdeasList currentSlide={currentSlide}
                        generatedSlides={generatedIdeas}
                        slideWidth={290}
                        onSelect={this.handleApplySlide}
                    />

                </PropertyPanelContainer>
            );
        }

        let metadata = currentSlide.getMetadata();

        return (
            <PropertyPanelContainer>
                <PropertyPanelHeader showCloseButton>Slide AI</PropertyPanelHeader>
                {/*<label>Slide Type:{currentSlide.getMetadata().slideType}</label>*/}
                {/*{metadata.slideContent &&*/}
                {/*    <div style={{ padding: 10, fontSize: 14, maxHeight: 300, overflowY: "scroll" }} dangerouslySetInnerHTML={{ __html: metadata?.slideContent }} />*/}
                {/*}*/}
                <PropertyPanelButton icon="change_circle"
                    title="Regenerate Slide..."
                    onClick={this.handleRegenerateSlide}
                />
                <PropertyPanelButton icon="photo"
                    title="Regenerate image..."
                    onClick={this.handleRegenerateImage}
                />
                <PropertyPanelButton icon="add"
                    title="Add slides with AI..."
                />
                {/*<PropertyPanelButton icon="summarize"*/}
                {/*    title="Add conclusion/takeaway..."*/}
                {/*    onClick={() => {*/}
                {/*    }}*/}
                {/*/>*/}
                {/*<PropertyPanelButton icon="photo"*/}
                {/*    title="Add an image..."*/}
                {/*    onClick={() => {*/}
                {/*    }}*/}
                {/*/>*/}
                {/*<PropertyPanelButton icon="spellcheck"*/}
                {/*    title="Rewrite content..."*/}
                {/*    onClick={() => {*/}
                {/*    }}*/}
                {/*/>*/}

            </PropertyPanelContainer>
        );
    }
}

export default SlideAiController.withState(SlideAiIdeasPanel);
